module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("3")])])]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Paul Myers was unpicking encrypted emails and eating his fourth Snickers of the day when he took Leila’s call. He’d always liked her, ever since she had attended his course on "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("jihadi")]), _vm._v(" chatrooms and had asked the first question, filling the awkward silence that always followed his introductory talks. All MI6’s new recruits were invited up to GCHQ in Cheltenham for a week, to give them a break from training at the Fort, and, Myers thought, to show them where the real work was done.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Paul had liked Leila’s boyfriend, too, though only begrudgingly at first. On the surface, Daniel Marchant had seemed to be the archetypal obnoxious MI6 man: Oxbridge, well travelled, smooth-talking, handsome and good at games – everything Myers wasn’t. But then he read his file and learnt about the dark stuff – the benders, the brawls, the twin brother who was killed when he was eight in a car crash in Delhi, the mother who never recovered, dying a depressive – and began to warm to him. Everyone in life was struggling to keep it together, he thought. According to Leila, Marchant had never got over losing his brother, and had been drinking himself slowly to death until he stumbled out of journalism and into the Service. It must have been like coming home, what with his old man running the show.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("They might have been friends sooner if Paul hadn’t somehow convinced himself that Leila carried a torch for him, despite the obvious chemistry between her and Marchant. He knew it was insane, an attractive case officer like her falling for a short-sighted, overweight desk analyst, and common sense soon prevailed, but those early feelings for her had stayed with him. Now she was on the phone, breathless and posing one of the most interesting questions he had been asked in months: could he screw up the Americans’ GPS network for a few minutes?")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Given the history of the navigation system, and in particular the US military’s policy of ‘selective availability’ in the 1990s, when they degraded the signal’s accuracy for everyone else, Myers relished the opportunity. Bring on Galileo, he thought, Europe’s own network of navigation satellites. The sooner Britain could wean itself off its dependency on GPS, the better.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Do you think you can do it?’ Leila asked, knowing that the challenge would appeal. Myers had been at the heart of a recent exercise in the West Country, when the entire network was jammed to thwart a simulated attack by an Iranian missile flying into British airspace on GPS. Car Tom-Toms went haywire, and the papers were full of stories the next day of lorries stuck in narrow country lanes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Technically it’s possible,’ Myers said, warming to his theme. ‘Each of the thirty GPS satellites has its own atomic clock – well, four clocks actually. 2nd Space Operations Squadron in Colorado Springs sends out a navigational update once a day to make sure they’re all telling the same time –’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Paul, we don’t have long.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sure. We’ll get on to 2 SOPS now, find out which four satellites this guy is linked in to, and see if they can accelerate those particular clocks.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Will that help?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’ll trick the receiver into thinking it’s travelling faster across the surface of the earth than it really is. The Americans aren’t going to like it, but I guess if we tell them their Ambassador is the target…How long do you need?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘The Bomb Squad want ten minutes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Two, maximum.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Two?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We’d have some serious shipping incidents in the Channel if those clocks are out for too long. I don’t even want to think about the main approach to Heathrow. How’s Daniel these days, by the way?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Myers was aware that Marchant was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("persona non grata")]), _vm._v(" in the Service, but he had always liked his father, and had been upset by the manner of the Chief’s departure and the subsequent news of his death. It had left Marchant an orphan, which struck a chord with Myers. He was adopted, and had always assumed his own parents were dead.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Actually, he’s running alongside the guy with the belt.’ Leila had not intended to tell him, but she needed to focus his mind.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Daniel?’ The line went silent for a moment. ‘Christ, what’s he doing there? I thought he was suspended.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Not now, Paul.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Sure.’ Paul had changed up a gear. ‘2 SOPS are on the other line. I’ll patch them through.’")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_vm._v("Marchant listened carefully as Leila talked him through what he had to do next. Her voice sounded different, faltering, lacking her usual confidence. Tower Bridge had been cleared of all crowds, she said. Half a mile ahead of him, at the twelve-mile point, there was about to be a roadblock, organised by plain-clothed police officers wearing race marshal tops. As he approached they would fan out across the road, using megaphones to order the runners to stop for safety reasons because of the intense heat. It would be the first time the London Marathon had been stopped, but the measure was not unheard of. (The Rotterdam Marathon had been abandoned in 2007 because of soaring temperatures.) In other words, there was an outside chance that the roadblock wouldn’t arouse the suspicion of Pradeep’s handler, should he be watching.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you all right?’ Marchant asked, after another hesitation from Leila.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Of course I’m bloody not,’ she said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant passed on the basic details of the plan, along with some more jelly beans, to Pradeep, who seemed to grow stronger at the news. The police would delay their intervention as long as possible, to avoid a crowd building up in front of them and slowing their pace. However, they should stick to the right of the road, as close as possible to the pavement, where a channel would be formed to let them pass through. To avoid being mistakenly challenged, Marchant was to call out that he was a doctor and must be allowed to pass.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Have you got all that?’ Leila asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘What happens when we’re through the block?’ Marchant replied. His mother had always wanted a doctor in the family.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘As you near Tower Bridge, the Americans are going to tweak the clocks on four GPS satellites orbiting 12,000 miles above you. When I give the word, you and Pradeep should gradually slow down to a walking pace. The Bomb Squad will join you and disable the belt as quickly as they can.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How long have they got?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Two minutes from the moment you start to slow.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant didn’t say anything for a few seconds. For the first time, he realised that his chances of survival were slim. Somehow he had assumed that everything would work out, but now he sensed that he might never see Leila again. She had already realised that. His life normally felt fairer in these moments of acute danger. Ever since that dark day in Delhi, he had been burdened with guilt: why had his brother been killed, while he walked away from the crash unscathed? When the odds were stacked against him, the weight briefly lifted: intense relief replaced the fear. The greater the danger, the closer he felt to Sebastian, the more able to look him in the eye.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("But that wasn’t the case now. There was no frisson of higher justice or fateful euphoria. His body just felt more tired than it had ever felt in his entire life, even more than when they had found him drunk in Nairobi, face down in the gutter, his last night as a journalist.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Are you still there?’ Leila said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I’m here.’ Another pause. He checked on Pradeep, who looked as if he had fallen into some sort of trance, eyes staring straight ahead, unaware of the outside world. But he was still running, that was all that mattered. ‘They’ve let you keep the mike then,’ Marchant continued.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Yes. In the circumstances, it was felt to be the best option.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Drop the formal tone, he thought, but he knew she couldn’t; all the agencies would have live feeds by now: Thames House, Cheltenham, Langley.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant imagined an aerial view of himself, as if taken from one of the satellites far above South London. He could picture the runners, tiny figures moving along toy streets, begin to bunch up in front of the police, who had appeared from nowhere. Zooming in on the scene, he could tell at once that there was no way through. Fifty yards out, he heard himself shouting at the top of his voice that he was a doctor. But no one else heard him. What was wrong with his voice? It sounded so faint, lost in the hubbub of the crowds, who were now jeering, protesting at the race being stopped. He shouted again, but his voice was too weak, barely audible above the sound of his own breathing, the megaphones, the helicopter above them. Pradeep looked at him in desperation as they began to slow down. And then Pradeep’s receiver beeped.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Leila, Leila, there’s no fucking way through!’ Marchant shouted into the phone. His hands were wet with sweat and he gripped the receiver tightly as he ran, like a relay baton. He could hear her talking urgently to other people in the background. ‘Jesus, Leila, we’re slowing down with five hundred people backing up in front of us.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Head left, head left!’ a voice was suddenly saying. It wasn’t Leila’s. Left? For a moment, all Marchant could think of was the blue tartan shoes he had as a child, ‘L’ and ‘R’ embroidered in red on the toes. Then Pradeep pointed ahead of them at a marshal who was beckoning frantically. He was trying to direct them over to the far side of the crowd, where marshals were pushing runners back, making a channel.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant couldn’t dredge up another word, let alone shout that he was a doctor, but in the end there was no need. They were suddenly through the roadblock, running on their own, the din of the crowd receding fast behind them. The marathon behemoth had spat them free.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Eight hundred yards ahead lay Tower Bridge, flags flying, eerily deserted. Marchant managed a faint smile, but not for long. Up until the roadblock, Pradeep’s mission would still have had the appearance of viability to any observer. Now, as the two of them ran on alone up the empty road, the suicide operation was blown. All Marchant could hope for was that Pradeep’s handler, if he had one out there, would wait until the iconic setting of Tower Bridge to cut his losses. The Ambassador wouldn’t die, there would be no ‘Carnage at the London Marathon’ headlines, but a suicide bombing at one of the capital’s most famous landmarks would still be worth something.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Leila?’ Marchant asked, still short of breath, struggling to grip the phone.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘We copy you,’ an American man’s voice said.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where’s Leila?’ he shouted. ‘Put Leila back on the line, do you hear?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘It’s OK, Daniel,’ a voice said. ‘She’s still here. We just patched you through directly to Colorado Springs. You’re now talking to me, Harriet Armstrong, in London.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The bitch, he thought, but he said nothing. He was too tired.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘They’re going to slow you down in a couple of minutes,’ Armstrong continued. ‘We’ve got two from the Bomb Squad waiting on the north side of the bridge. As soon as you’re walking, they’ll move in. Try to get more out of Pradeep. Cell names, contacts, who’s running him, anything. We’ll call you back in two minutes.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("It felt strange to run the London Marathon through deserted streets. He had always liked empty spaces, big yawning skies, mountains, the open sea. In cities he felt trapped, but he could live here if it was always like this. He suddenly thought of the Thar Desert, trudging over sand dunes with Sebastian on a camel beside him, their parents up ahead, smiling back at them.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("As far as Marchant could tell, the police had cleared a corridor a hundred yards either side of the route. For a moment, he imagined that he was leading the field with Pradeep, having broken away from the leading pack in a ruthless final kick for home. Then his legs reminded him how tired he felt.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Where are you from, Pradeep?’ he asked. ‘Which part of India?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘How do you know I’m from India?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘I used to live there.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Which place?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Delhi. Chanakyapuri.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Very nice,’ Pradeep said, moving his head from side to side, managing a faint smile. Talk of home seemed to give him strength.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘All I remember is the yellow blossom of the laburnum trees. I was very young.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("For a few seconds their steps were synchronised, rising and falling together. They both noticed it, momentarily entranced. ‘Are we going to die?’ Pradeep asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘No. We’re not.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My home place is Kochi.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Kerala?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘My wife, she is also from there. We have one son, living with us in Delhi. They will kill him if I don’t do this today.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Who’s “they”?’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Pradeep didn’t answer. Instead, he pulled out a small photo from a pouch at the front of the belt and showed it to Marchant.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant looked at the young face that smiled back at him. This hadn’t been a part of his calculations. Pradeep might have been a reluctant bomber, but he now had a motive to see it through. His heart sank. Pradeep had missed his target, the Ambassador, but he could still honour his word by blowing himself up at Tower Bridge to save his son. Marchant glanced at his watch: one hour thirty-nine minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘But you don’t want to go through with this, do you?’ he asked. ‘You don’t want to die.’ Before Pradeep could answer, Marchant’s phone started to ring. It was Colorado Springs.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Again, Marchant imagined himself from high above, the bridge looking even more like a child’s model than it did from the ground. He listened to the young American on the phone, calm and authoritative, talking to him, to Armstrong, to someone else. And then, at last, it was time to slow down.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘If the GPS makes any sound at all, increase your speed immediately, do you copy that?’ the American asked.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Copy that.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Now take it down slowly, sir. Your window is open. Two minutes and counting.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant looked at Pradeep, suddenly unsure of his cooperation. For so long he had wanted him to keep on running; now he was praying he would slow down. But Pradeep’s pace remained constant, his eyes looking straight ahead. If anything, he was growing stronger. He was hanging on until they reached the bridge.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("‘Remember, you’ve got time to speed up again if the GPS doesn’t like it,’ the American said. ‘Ease it down now. One minute forty-five and counting.’")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant moved closer to Pradeep and grabbed his arm. ‘It’s OK, we can slow down. We can stop. We’ve done it.’ They were at the edge of the bridge, approaching the first tower, still not slowing. Marchant knew that tears were mixing with Pradeep’s sweat as he tried to struggle on, for his young son, to the middle of the bridge. But his legs were beginning to buckle, first one, then the other, and soon he was in Marchant’s arms, sobbing, as they slowed to a walking pace. Marchant glanced at his receiver to check their speed: it still said that they were running at eight minutes per mile.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("Marchant never established the exact order of what happened next. He remembered two bomb disposal officers, weighed down with protective khaki clothing, running across from the far side of the bridge, shouting at him to remain where he was. And he later learnt that at the same time, somewhere in the skies above Heathrow, two passenger planes started their final approaches sooner than they should have, setting themselves on a collision course that was only averted by an extra-vigilant air traffic controller.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The double-tap gunshot that rang out on the bridge, jerking Pradeep’s head back, must have been fired just before the bomb disposal squad reached them. Marchant remembered holding Pradeep’s limp body for a second and then slumping down with him to the tarmac. The two dum-dum bullets had spread out inside Pradeep’s skull, rather than passing through it. The back of his head felt like moist moss.")]), _vm._v(" "), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_vm._v("The belt was cut free and disarmed in the subsequent blur, but as Marchant was led away in a cacophony of sirens, all he could recall thinking about was Pradeep’s son, and whether he would now be allowed to live.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac53f62","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780312644765_ch03.vue
// module id = 75
// module chunks = 0